import * as React from 'react';
import {DateInput, SelectInput, TextInput,} from 'react-admin';
import { returnStates } from './returnStates';
import {SOURCE} from "../OrderList";

const sourceKeys = Object.keys(SOURCE);
const sourceChoices = Object.values(SOURCE).map((source, k) => {
    return {
        id: sourceKeys[k],
        name: source
    }
});

const orderReturnsFilters = () => {
    return [
        <SelectInput
            alwaysOn
            source="status"
            choices={Object.values(returnStates)}
            label={`resources.order.return.fields.status`}
            optionText="translationKey"
        />,
        <SelectInput
            alwaysOn
            source="order.source"
            choices={sourceChoices}
            label={`resources.order.return.fields.source`}
        />,
        <TextInput
            source="order.number"
            name="order.number"
            label={`resources.order.return.fields.orderNumber`}
        />,
        <TextInput
            source="number"
            name="number"
            label={`resources.order.return.fields.number`}
        />,
        <DateInput
            source="createdAt_gte"
            name="createdAt_gte"
            label={`resources.order.return.requested_since`}
        />,
        <DateInput
            source="createdAt_lte"
            name="createdAt_lte"
            label={`resources.order.return.requested_before`}
        />
    ];
}

export default orderReturnsFilters;
